import { Button, Col, Dropdown, Form, Input, Row, Select, Tooltip } from 'antd';
import {useCallback, useEffect, useState } from 'react';
import ActionsComponent from '../shared/ActionsComponent';
import { handleOnKeyDown } from 'src/utils/service';
import HeaderComponent from '../header';
const Filters = (props) => {
    const [open, setOpen] = useState(false);
    const [form]=Form.useForm()
    useEffect(() =>{
     form.setFieldsValue(props?.filterValues);
     if (props?.onloadGrid) {
        props.onloadGrid();}
    },[props?.filterValues])
    const handleSearch = useCallback((values) => {
        const trimmedValues = {
            ...values,
            programName: values?.programName?.trim()
        };
        props?.filterObj(trimmedValues);
        setOpen(false);
    },[props])

    const handleOpenChange = useCallback((nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setOpen(nextOpen);
        }
    },[])
    const handleMenuClick = (e) => {
        if (e.key === '3') {
            setOpen(false);
        }
    };
    const clearRecords = useCallback(() => {
        props?.filterObj({ "programName": null,"currency": null, state: null });
        form.resetFields()
      },[form,props])

    const items = [
        {
            label: 
                <Form className="grid-filter-form"
                    autoComplete="off"
                    onFinish={handleSearch}
                    form={form}>
                    <p className='filter-option-title'>Filter Options</p>
                    <Row gutter={16} className='filters-row'>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                className='input-style'
                                label="Program Name"
                                name="programName"
                                rules={[
                                    {
                                        validator(_, value) {
                                            if (value && !/^[a-zA-Z0-9\s\-()]+$/.test(value)) {
                                                return Promise.reject("Invalid Program name");
                                            } else {
                                                return Promise.resolve();
                                            }
                                        },
                                    },]}
                            >
                                <Input placeholder='Enter Program Name' tabIndex={1} onKeyDown={handleOnKeyDown}/>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <Form.Item className='' label="Select Currency" name="currency">
                            <Select
                                className=""
                                placeholder={`Select currency`}
                                tabIndex={2}
                            >
                                {props?.currencyLu?.map((item) => (
                                    <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item className='' label="Status" name="state">
                                <Select
                                    className="mb-0"
                                    placeholder={`Select Status`}
                                >
                                    {props?.statusLuData?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                        <Button className='cancel-btn' onClick={clearRecords} key="back">Clear</Button>
                        <Button className='primary-btn' type="primary" htmlType="submit">Search</Button></div>
                </Form>,
            key: '1',
        },
    ];
    const onActionClick = useCallback((key) => {
        handleToolBarActions(key)
      },[])

    const handleToolBarActions = useCallback((action) => {
        if (action === 'exportexcel') {
            props?.handleExcelExport();
        }
    },[props])
    const breadCrumbList = [
        { bname: 'Services' },
      ]
    return (
        <>
        <div><HeaderComponent breadCrumbList={breadCrumbList} /></div>
           <div className='flex gap-2 justify-end items-center mb-3'> 
              <ActionsComponent serviceName={"CardsManageService.Settings"} onActionClick={onActionClick}  targetTabName="Programs"/>
            <Dropdown
           overlayClassName='filterdropdown-overlay'
            className='filter-dropdown'
                menu={{
                    items,
                    onClick: handleMenuClick,
                }}
                onOpenChange={handleOpenChange}
                open={open}
                trigger={'click'}
            >
                <a onClick={(e) => e.preventDefault()} className=''>
                   <Tooltip title='Filter'>   <span className='icon filter-icon-dropdown'></span></Tooltip>
                </a>
            </Dropdown>
            </div>
            </>
    )
}
export default Filters;